import React, { ForwardedRef } from "react";
import { TextField } from "..";
import Search from "@tiny/icons/generated/Search";
import CloseBig from "@tiny/icons/generated/CloseBig";
import { SearchFieldProps } from "./SearchField.types";
import { useStyles } from "./SearchField.styles";

function SearchField(
  props: SearchFieldProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  const { onChangeValue, onKeyDown, value, ...other } = props;

  const classes = useStyles();

  const handleClear = React.useCallback(() => {
    onChangeValue?.("");
  }, [onChangeValue]);

  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (event.key === "Escape") {
        onChangeValue?.("");
      }
      onKeyDown?.(event);
    },
    [onChangeValue, onKeyDown]
  );

  const endIcon = value ? (
    <button type="button" onClick={handleClear} title="Clear (ESC)">
      <CloseBig className={classes.icon} />
    </button>
  ) : (
    <Search className={classes.icon} />
  );

  return (
    <TextField
      {...other}
      ref={ref}
      onChangeValue={onChangeValue}
      endIcon={endIcon}
      value={value}
      onKeyDown={handleKeyDown}
    />
  );
}

export default React.forwardRef(SearchField);
